(function () {
  function initReader(reader) {
    if (reader.dataset.initialized === "true") return;
    reader.dataset.initialized = "true";

    var dataScript = reader.querySelector("[data-editorial-issues]");
    var issues = JSON.parse(dataScript.textContent);
    var issueButtons = Array.prototype.slice.call(reader.querySelectorAll("[data-editorial-issue]"));
    var viewport = reader.querySelector("[data-editorial-viewport]");
    var frame = reader.querySelector("[data-editorial-frame]");
    var leftImage = reader.querySelector("[data-editorial-left-image]");
    var rightImage = reader.querySelector("[data-editorial-right-image]");
    var current = reader.querySelector("[data-editorial-current]");
    var activeTitle = reader.querySelector("[data-editorial-active-title]");
    var activeCount = reader.querySelector("[data-editorial-active-count]");
    var prev = reader.querySelector("[data-editorial-prev]");
    var next = reader.querySelector("[data-editorial-next]");
    var zoom = reader.querySelector("[data-editorial-zoom]");
    var fullscreen = reader.querySelector("[data-editorial-fullscreen]");
    var thumbnails = reader.querySelector("[data-editorial-thumbnails]");
    var activeIssue = issues[0];
    var spreads = [];
    var spreadIndex = 0;
    var touchStartX = 0;
    var touchStartY = 0;

    function buildSpreads(pageCount) {
      var built = [[1]];
      for (var page = 2; page <= pageCount; page += 2) {
        built.push(page + 1 <= pageCount ? [page, page + 1] : [page]);
      }
      return built;
    }

    function spreadLabel(spread) {
      return spread.length === 1 ? "Page " + spread[0] : "Pages " + spread[0] + "-" + spread[1];
    }

    function spreadIndexForPage(page) {
      if (page <= 1) return 0;
      return Math.ceil((page - 1) / 2);
    }

    function setIssue(issueId) {
      var nextIssue = issues.find(function (issue) { return issue.id === issueId; }) || issues[0];
      activeIssue = nextIssue;
      spreads = buildSpreads(activeIssue.pages.length);
      spreadIndex = 0;
      reader.classList.remove("is-zoomed");
      if (zoom) zoom.textContent = "Zoom";
      viewport.scrollTo({ top: 0, left: 0, behavior: "auto" });
      activeTitle.textContent = activeIssue.title;
      activeCount.textContent = activeIssue.pages.length + " pages";

      issueButtons.forEach(function (button) {
        button.setAttribute("aria-current", button.dataset.issueId === activeIssue.id ? "true" : "false");
      });

      buildThumbnails();
      renderSpread(0);
    }

    function buildThumbnails() {
      thumbnails.textContent = "";
      activeIssue.pages.forEach(function (src, index) {
        var page = index + 1;
        var button = document.createElement("button");
        button.type = "button";
        button.className = "editorial-reader-thumb";
        button.setAttribute("aria-label", "Open " + activeIssue.title + " page " + page);
        button.dataset.page = String(page);

        var image = document.createElement("img");
        image.src = src;
        image.alt = "";
        image.loading = page <= 4 ? "eager" : "lazy";

        button.appendChild(image);
        button.addEventListener("click", function () {
          var nextIndex = spreadIndexForPage(page);
          renderSpread(nextIndex, nextIndex < spreadIndex ? "prev" : "next");
        });
        thumbnails.appendChild(button);
      });
    }

    function renderSpread(nextIndex, direction) {
      var boundedIndex = Math.min(Math.max(nextIndex, 0), spreads.length - 1);
      if (boundedIndex === spreadIndex && direction) return;

      spreadIndex = boundedIndex;
      var spread = spreads[spreadIndex];
      var isCover = spread.length === 1;

      frame.classList.toggle("is-cover", isCover);
      frame.classList.toggle("is-spread", !isCover);
      leftImage.src = activeIssue.pages[spread[0] - 1];
      leftImage.alt = activeIssue.title + " page " + spread[0];

      if (isCover) {
        rightImage.removeAttribute("src");
        rightImage.alt = "";
      } else {
        rightImage.src = activeIssue.pages[spread[1] - 1];
        rightImage.alt = activeIssue.title + " page " + spread[1];
      }

      current.textContent = spreadLabel(spread);
      prev.disabled = spreadIndex === 0;
      next.disabled = spreadIndex === spreads.length - 1;

      frame.classList.remove("turn-next", "turn-prev");
      void frame.offsetWidth;
      frame.classList.add(direction === "prev" ? "turn-prev" : "turn-next");

      Array.prototype.slice.call(thumbnails.querySelectorAll("[data-page]")).forEach(function (button) {
        var page = Number(button.dataset.page);
        var active = spread.indexOf(page) !== -1;
        button.setAttribute("aria-current", active ? "page" : "false");
        if (active && page === spread[0]) {
          button.scrollIntoView({ inline: "center", block: "nearest", behavior: "smooth" });
        }
      });
    }

    function go(delta) {
      renderSpread(spreadIndex + delta, delta < 0 ? "prev" : "next");
    }

    function setZoom(isZoomed) {
      reader.classList.toggle("is-zoomed", isZoomed);
      if (zoom) zoom.textContent = isZoomed ? "Fit" : "Zoom";

      function centerZoomedFrame() {
        viewport.scrollTo({
          top: 0,
          left: Math.max((viewport.scrollWidth - viewport.clientWidth) / 2, 0),
          behavior: "smooth"
        });
      }

      window.requestAnimationFrame(function () {
        centerZoomedFrame();
        window.setTimeout(centerZoomedFrame, 220);
      });
    }

    issueButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        setIssue(button.dataset.issueId);
      });
    });

    prev.addEventListener("click", function () { go(-1); });
    next.addEventListener("click", function () { go(1); });

    viewport.addEventListener("keydown", function (event) {
      if (event.key === "ArrowLeft") go(-1);
      if (event.key === "ArrowRight") go(1);
      if (event.key === "+" || event.key === "=") setZoom(true);
      if (event.key === "-") setZoom(false);
    });

    viewport.addEventListener("pointerdown", function (event) {
      touchStartX = event.clientX;
      touchStartY = event.clientY;
    });

    viewport.addEventListener("pointerup", function (event) {
      var dx = event.clientX - touchStartX;
      var dy = event.clientY - touchStartY;
      if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.4) {
        go(dx > 0 ? -1 : 1);
      }
    });

    if (zoom) {
      zoom.addEventListener("click", function () {
        setZoom(!reader.classList.contains("is-zoomed"));
      });
    }

    if (fullscreen) {
      fullscreen.addEventListener("click", function () {
        if (!document.fullscreenElement && reader.requestFullscreen) {
          reader.requestFullscreen();
        } else if (document.exitFullscreen) {
          document.exitFullscreen();
        }
      });
    }

    setIssue(issues[0].id);
  }

  function initAllReaders() {
    document.querySelectorAll("[data-editorial-reader]").forEach(initReader);
  }

  document.addEventListener("DOMContentLoaded", initAllReaders);
  document.addEventListener("shopify:section:load", initAllReaders);
})();
